import { useEffect, useState } from 'react'
import {
  getstorelistbyID,
  updateStore,
  validatesitemapurl
} from '../../../services/data'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import validateJSON from '../../../util/jsonvalidation'
import Cookies from 'js-cookie'
import { useAuth } from '../../../context/logincontext'
import { useLocation, useParams } from 'react-router-dom'

const StoreUpdateSettings = ({ close, storetype }) => {
  const [meta, setMeta] = useState('')
  const [storename, setStoreName] = useState('')
  const { userdata } = useAuth()
    const location = useLocation()
    const params = useParams()
    
      // ✅ Extract store_id from URL (params or pathname)
      const getStoreIdFromUrl = () => {
        if (params?.store_id) return params.store_id
        const pathParts = location.pathname.split('/')
        console.log(pathParts[1])
        return pathParts[1] || null
      }
    
      const storeid = getStoreIdFromUrl()

  useEffect(() => {
    const fetchMetaDetails = async () => {
      try {
        const storeId = storeid
        const store = await getstorelistbyID(storeId)

        setStoreName(store.data.name)

        let metaData = store.data.meta
        if (typeof metaData === 'string') {
          try {
            metaData = validateJSON(metaData)
          } catch (error) {
            console.error('Failed to parse meta JSON:', error)
            toast.error('Invalid meta data format.')
            return
          }
        }

        setMeta(metaData?.[storetype === 'website' ? 'sitemap' : 'token'] || '')
      } catch (error) {
        toast.error('Failed to fetch store data.')
      }
    }

    fetchMetaDetails()
  }, [storetype])

  const handleUpdate = async () => {
    const payload = {
      name: storename,
      type: storetype,
      user_id: validateJSON(userdata),
      // user_id: validateJSON(userdata).id,
      // user_id: validateJSON(Cookies.get('user')).id,
      meta: {
        [storetype === 'website' ? 'sitemap' : 'token']: meta
      }
    }

    console.log(payload)

    try {
      if (storetype === 'website') {
        const res = await validatesitemapurl({ sitemapUrl: meta })
        if (!res.success) {
          toast.error(res.message || 'Sitemap validation failed.', {
            position: 'bottom-center'
          })
          return // Stop if sitemap is invalid
        }
        toast.success(res.message, {
          position: 'bottom-center'
        })
      }

      await updateStore(storeid, payload)
      toast.success('Store updated successfully.', {
        position: 'bottom-center'
      })

      close()
    } catch (error) {
      toast.error('Failed to update store.', {
        position: 'bottom-center'
      })
    }
  }

  return (
    <div className='fixed inset-0 bg-black bg-opacity-25 flex justify-center items-center z-50'>
      <div className='bg-white rounded-[24px] w-[456px] min-h-[240px] border border-white shadow flex flex-col'>
        {/* Header */}
        <div className='flex justify-between items-center px-6 py-4 border-b'>
          <h2 className='font-extrabold text-[18px]'>
            {storetype === 'website' ? 'Update SiteMap' : 'Update Access Token'}
          </h2>
          <button
            className='w-[30px] sm:w-[40px] h-[30px] sm:h-[40px]'
            onClick={close}
          >
            <svg width='30' height='30' viewBox='0 0 30 30' fill='none'>
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M9.1 7.77a.925.925 0 00-1.3 1.3L13.67 15l-5.9 5.9a.925.925 0 101.3 1.3L15 16.33l5.9 5.9a.925.925 0 101.3-1.3L16.33 15l5.9-5.9a.925.925 0 00-1.3-1.3L15 13.67l-5.9-5.9z'
                fill='#373737'
              />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className='px-6 py-4 text-sm text-gray-700'>
          <input
            type='text'
            value={meta}
            onChange={e => setMeta(e.target.value)}
            placeholder='Enter value'
            className='w-full border border-black/30 py-2 px-3 rounded-lg text-sm focus:outline-none'
          />
        </div>

        {/* Footer */}
        <div className='mt-auto flex justify-end px-6 py-4 border-t'>
          <button
            onClick={handleUpdate}
            className='bg-black text-white px-6 py-2 rounded-full text-sm font-bold hover:bg-gray-900 transition w-full md:w-auto'
          >
            Update
          </button>
        </div>
      </div>
    </div>
  )
}

export default StoreUpdateSettings
